import classNames from 'classnames';
import React from 'react';
import Check from 'wix-ui-icons-common/Check';
import styles from './progress.scss';

interface Props {
  progress: number;
  width: number;
  height: number;
  circleClassName?: string;
  completeIconSize?: number;
}

const STROKE_WIDTH = 2;

const Progress: React.FunctionComponent<Props> = ({
  progress,
  width,
  height,
  circleClassName,
  completeIconSize,
}: Props) => {
  const radius = (width - STROKE_WIDTH) / 2;
  const circle = Math.PI * (radius * 2);
  const offset = ((100 - progress) / 100) * circle;
  const circleClassNames = classNames(styles.circle, circleClassName);
  const iconSize = completeIconSize ? completeIconSize : 18;

  return (
    <div className={styles.container} style={{ width, height }}>
      <svg className={styles.svg} width={width} height={height}>
        <circle
          className={circleClassNames}
          r={radius}
          cx="10"
          cy="10"
          fill="transparent"
        />
        <circle
          className={classNames(circleClassNames, styles.bar)}
          r={radius}
          cx="10"
          cy="10"
          fill="transparent"
          strokeDasharray={circle}
          strokeDashoffset="0"
          style={{ strokeDashoffset: offset }}
        />
      </svg>

      {progress === 100 ? (
        <div className={styles.completeIcon} style={{ width, height }}>
          <Check size={`${iconSize}px`} />
        </div>
      ) : null}
    </div>
  );
};

Progress.defaultProps = {
  width: 20,
  height: 20,
};

export default Progress;
